<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-4"
        v-model.trim="fieldsValues.name" v-bind="fieldsDefinitions.name"
        @error="(err) => setFieldError('name', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.version" v-bind="fieldsDefinitions.version"
        @error="(err) => setFieldError('version', err)"/>
      <ccs-input class="ccs-4" v-model="fieldsValues.file" v-bind="fieldsDefinitions.file"
      :required="!isEditing"  :allowFileDelete="!isEditing" accept="*"
        @error="(err) => setFieldError('file', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить и добавить
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'EventFile',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        name: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Название",
          placeholder: "Введите название",
        },
        version: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Версия",
          placeholder: "Введите версию",
        },
        file: {
          isValid: false,
          error: '',
          required: true,
          type: "file",
          label: "Файл",
        },
      },
      fieldsValues: {
        id: undefined,
        file: null,
        name: '',
        version: '',
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapState('events', ['event']),
    isEditing() {
      return this.$props.data && this.$props.data.id;
    }
  },
  methods: {
    ...mapActions('session', ['uploadFile', 'replaceFile']),
    ...mapActions('events', ['getEvent']),
    async submit() {
      if (this.fieldsValues.id) {
        await this.editFile();
      } else {
        await this.addFile();
      }
    },
    async addFile() {
      this.validateForm();
      if (this.isFormValid) {
        try {
          const result = await this.uploadFile({
            file: this.fieldsValues.file,
            entityID: this.event.id,
            entityType: 'events',
            fileType: 'document',
            fileName: this.fieldsValues.name,
            fileVersion: this.fieldsValues.version,
          });
          this.getEvent();
          this.$toasted.success('Файл добавлен');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
    async editFile() {
      this.fieldsDefinitions.file.required = false;
      this.validateForm();
      if (this.isFormValid) {
        try {
          let payload = {
            fileID: this.fieldsValues.id,
            fileName: this.fieldsValues.name,
            fileVersion: this.fieldsValues.version,
          };
          if (!!this.fieldsValues.file) payload.file = this.fieldsValues.file;
          await this.replaceFile(payload);
          this.getEvent();
          this.$toasted.success('Файл изменен');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
  },
  created() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = Object.assign({}, this.$props.data);
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
